import styled, { css } from 'styled-components'

export const Wrapper = styled.div`
  ${({ theme }) => css`
    padding: 0 0 24px 0;
    display: flex;
    flex-direction: column;
    border-radius: ${theme.border.radius.small};
    background-color: ${theme.colors.white};
    height: 100%;
  `}
`
